import React from 'react'
import Game from './Game'
import { render, getConfig, CONTENT_TYPE, initErrorMonitoring } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { createCustomization } from '@educaplay/core/utils/customization'

initErrorMonitoring("https://1ac0e21b047b6094e3b195aecbbf1b05@o4509038211104768.ingest.de.sentry.io/4510301863280720");

const gameImage = assetsUrl("PRESENTACION/logoActivity.png");
const container = document.getElementById('root');

function isValidSlice(slice) {
    return slice.TEXTO !== "" || slice.MULTIMEDIA;
}

async function init() {
  const { data, texts, settings, user, title, description, author, id, url} = await getConfig().catch((err) => 
    console.error('Error al obtener la configuración: ', err)
  )

  const { resources } = settings
  const { SLIDES } = data;

  const slides = SLIDES
    .filter(isValidSlice)
    .map((slice, index) => ({
      id: `slice-${index}`,
      title: slice.TITLE,
      content: slice.TEXTO,
      media: slice.MULTIMEDIA ? {
        source :slice.MULTIMEDIA_TIPO === CONTENT_TYPE.YOUTUBE ? slice.MULTIMEDIA : `${resources}${slice.MULTIMEDIA}`,
        type: slice.MULTIMEDIA_TIPO,
        title: slice.MULTIMEDIA_TITLE
      } : null
    }))

    const sliceConfig = {
      id: "slides",
      bank: null,
      checkAnswer: () => true,
      answer: null,
      points: 100,
      media: null,
      slides
  }

  initialize({
    lives: data.NUMERO_INTENTOS, //COMPROBAR SI ES MAXIMO
    liveActived: !!data.NUMERO_INTENTOS_INFINITOS && data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.TIEMPO_INFINITO === "no",
    randomized: data.ALEATORIO === "si",
    showSolutions: false,
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    hasBank: false,
    questions: [sliceConfig],
    settings,
    title,
    description,
    author,
    id,
    user,
    url,
    showButtonReports: false,
    customizations: createCustomization(data)
  });

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        mappers={{
          report: () => {}
        }}
      />
    </React.StrictMode>
  ))
}

init();